import * as React from 'react'
import { DragLayer, XYCoord, DragLayerMonitor } from 'react-dnd'
import { NodeDrag } from 'src/view/drags';

// import domtoimage from 'dom-to-image';
import { FixDnd } from 'src/view/DragAndDrop';


const layerStyles: React.CSSProperties = {
	position: 'fixed',
	pointerEvents: 'none',
  zIndex: 1000,
  opacity: 0.7,
	left: 0,
	top: 0,
	width: '100%',
	height: '100%',
}

function getItemStyles(props: ReturnType<typeof dragLayerCollect>) {
	const { initialOffset, currentOffset, initialPointer, item } = props
	if (!initialOffset || !currentOffset || !initialPointer) {
		return {
			display: 'none',
		}
	}

	let { x, y } = currentOffset

  const nodeDrag = item as NodeDrag
  if (nodeDrag.domElementOffset) {
    x += nodeDrag.domElementOffset.x
    y += nodeDrag.domElementOffset.y
  }

	const transform = `translate(${x}px, ${y}px)`
	return {
		transform,
		WebkitTransform: transform,
	}
}

class CustomDragLayer extends React.Component<ReturnType<typeof dragLayerCollect>> {
  nodeOrig: Node | undefined
  nodeCopy: Node | undefined
  itemRef = React.createRef<HTMLDivElement>()

  render () {
    const { isDragging } = this.props

    if (!isDragging) {
      this.nodeOrig = undefined
      this.nodeCopy = undefined
      return null
    }

    return (
      <div style={layerStyles}>
        <div style={getItemStyles(this.props)} ref={this.itemRef}></div>
      </div>
    )
  }

  sync() {
    const { item, itemType, isDragging } = this.props
    const nodeDrag = item as NodeDrag
    
    if (!isDragging) { return }

    if (!this.itemRef.current) { return }

    if (!nodeDrag.domElement) { return }

    try {
      if (nodeDrag.domElement !== this.nodeOrig) {
        this.nodeOrig = nodeDrag.domElement
        this.nodeCopy = nodeDrag.domElement.cloneNode(true)
        while (this.itemRef.current.firstChild) {
          this.itemRef.current.removeChild(this.itemRef.current.firstChild)
        }
        this.itemRef.current.appendChild(this.nodeCopy)
      }
    } catch (e) {

    }
  }

  componentDidMount() {
    this.sync()
  }

  componentDidUpdate() {
    this.sync()
  }
}

function dragLayerCollect(monitor: DragLayerMonitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    initialPointer: monitor.getInitialClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }
}

export default FixDnd(DragLayer(dragLayerCollect)(CustomDragLayer))


// WEBPACK FOOTER //
// ./src/view/CustomDragLayer.tsx